import { useState, useRef, useEffect } from "react";
import { default as ReactSelect } from "react-select";
import MultiSelectDropdown from "../../components/MultiSelectDropdown/MultiSelectDropdown";
import FormSingleLineInput from "../../components/FormSingleLineInput/FormSingleLineInput";
import FormTextAreaInput from "../../components/FormTextAreaInput/FormTextAreaInput";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import Results from "../Results/Results";
import Dropdown from "../../components/Dropdown/Dropdown";
import { transform } from "../../utils";
import "./setup.css";

const sizes = [
  {
    value: "2 piece Players Lite",
    label: "2 piece Players Lite",
    description: "1.5 hours hours, as 2 x 45 minutes or 3 x 30 interatice sets",
    price: 200,
  },
  {
    value: "3 piece Players Lite",
    label: "3 piece Players Lite",
    description: "Includes lorem ipsum, dolor sit amet, and adipiscing",
    price: 300,
  },
  {
    value: "4 piece Players",
    label: "4 piece Players",
    description: "1 hour aperitivo set",
    price: 400,
  },
  {
    value: "5 piece Players",
    label: "5 piece Players",
    description: "1 hour aperitivo set",
    price: 500,
  },
  {
    value: "6 piece Players",
    label: "6 piece Players",
    description: "1 hour aperitivo set",
    price: 600,
  },
];

const performers = [
  {
    value: "The Roameo Players",
    label: "The Roameo Players",
    description: "1.5 hours hours, as 2 x 45 minutes or 3 x 30 interatice sets",
    price: 250,
  },
  {
    value: "Players Lite",
    label: "Players Lite",
    description: "Includes lorem ipsum, dolor sit amet, and adipiscing",
    price: 250,
  },
  {
    value: "The Roameo Jazz Band",
    label: "The Roameo Jazz Band",
    description: "1 hour aperitivo set",
    price: 250,
  },
  {
    value: "Afro Fiya",
    label: "Afro Fiya",
    description: "1 hour aperitivo set",
    price: 250,
  },
  {
    value: "Miss Loulu",
    label: "Miss Loulu",
    description: "1 hour aperitivo set",
    price: 250,
  },
];

const djs = [
  {
    value: "Independant Dj - 4 hours",
    label: "Independant Dj - 4 hours",
    description: "1.5 hours hours, as 2 x 45 minutes or 3 x 30 interatice sets",
    price: 400,
  },
  {
    value: "Musician to DJ - 2 hours",
    label: "Musician to DJ - 2 hours",
    description: "Includes lorem ipsum, dolor sit amet, and adipiscing",
    price: 200,
  },
  {
    value: "Musician to DJ - 3 hours",
    label: "Musician to DJ - 3 hours",
    description: "1 hour aperitivo set",
    price: 300,
  },
];

const SearchParams = () => {
  const [when, setWhen] = useState("");
  const [where, setWhere] = useState("");
  const [sizeBand, setSizeBand] = useState("");
  const [performer, setPerformer] = useState("");
  const [playingTime, setPlayingTime] = useState([]);
  const [dj, setDj] = useState("");

  const [selectedOption, setSelectedOption] = useState("");

  const [price, setPrice] = useState(2000);
  // to handle edge case of empty experts array before first api call
  const [buttonClicked, setButtonClicked] = useState(false);

  // error handling hooks
  const [whenError, setWhenError] = useState(false);
  const [whereError, setWhereError] = useState(false);
  const [typeOfPeopleError, setTypeOfPeopleError] = useState(false);
  const [exampleNamesError, setExampleNamesError] = useState(false);
  const [typeOfInfoError, setTypeOfInfoError] = useState(false);

  // api invalid payload hook

  // button disabling & checking all required inputs are valid before api call
  // const isValid =
  //   typeOfPeople.length > 0 && exampleNames.length > 0 && typeOfInfo.length > 0;

  const handleSubmit = (event) => {
    event.preventDefault();
    window.scrollTo(0, 0);
  };

  const handleClick = () => {
    !when && setWhenError(true);
    !where && setWhereError(true);

    // typeOfPeople.length > 0 && setTypeOfPeopleError(false);
    // exampleNames.length > 0 && setExampleNamesError(false);
    // typeOfInfo.length > 0 && setTypeOfInfoError(false);
    // !typeOfPeople && setTypeOfPeopleError(true);
    // !exampleNames && setExampleNamesError(true);
    // !typeOfInfo.length && setTypeOfInfoError(true);
    setButtonClicked(true);
  };

  const handlePriceChange = (parameter) => {
    parameter === "city" && setPrice(price + 500);
    if (parameter === "band") {
      console.log("whoooooo ", sizeBand.price);
      setPrice(price + sizeBand.price);
    }
  };

  const handleBandChange = (selectedOption) => {
    console.log("selected option ", selectedOption);
    setSizeBand(selectedOption);
    setPrice(price + selectedOption.price);
  };

  const handlePerformerChange = (selectedOption) => {
    console.log("selected option ", selectedOption);
    setPerformer(selectedOption);
    setPrice(price + selectedOption.price);
  };

  const handleDjChange = (selectedOption) => {
    console.log("selected option ", selectedOption);
    setDj(selectedOption);
    setPrice(price + selectedOption.price);
  };

  return (
    <div className="search-params">
      <div className="setup">
        <h1 className="section-title"></h1>

        <form onSubmit={handleSubmit}>
          <FormSingleLineInput
            setInput={setWhen}
            isError={whenError}
            title="When is your event?"
            placeholder="00-00-00"
          />

          <FormSingleLineInput
            setInput={setWhere}
            handlePriceChange={() => handlePriceChange("city")}
            price={price}
            isError={whereError}
            title="Where is your event?"
            placeholder="Barcelona"
          />

          <div className="form-element">
            <h2 className="prompt">What size band would you like?</h2>
            <ReactSelect options={sizes} onChange={handleBandChange} />
            {typeOfInfoError && (
              <ErrorMessage message="please select some options before continuing" />
            )}
          </div>

          <div className="form-element">
            <h2 className="prompt">
              Do you want to reserve a particular performer?
            </h2>
            <ReactSelect
              options={performers}
              onChange={handlePerformerChange}
            />
            {typeOfInfoError && (
              <ErrorMessage message="please select some options before continuing" />
            )}
          </div>

          <div className="form-element">
            <h2 className="prompt">How much playing time?</h2>
            <MultiSelectDropdown
              setPlayingTime={setPlayingTime}
              typeOfInfoError={typeOfInfoError}
            />
            {typeOfInfoError && (
              <ErrorMessage message="please select some options before continuing" />
            )}
          </div>

          <div className="form-element">
            <h2 className="prompt">Do you want us to provide a DJ?</h2>
            <ReactSelect options={djs} onChange={handleDjChange} />
            {typeOfInfoError && (
              <ErrorMessage message="please select some options before continuing" />
            )}
          </div>

          {/* <button className="button" onClick={handleClick}>
            Submit
          </button> */}
        </form>
      </div>
      <div className="results">
        <h1 className="section-title"></h1>
        {!typeOfPeopleError && !exampleNamesError && !typeOfInfoError ? (
          <Results
            price={price}
            when={when}
            where={where}
            sizeBand={sizeBand}
            performer={performer}
            playingTime={playingTime}
            dj={dj}
            buttonClicked={buttonClicked}
          />
        ) : (
          <ErrorMessage message="Please fill in any missing fields and re-run your search" />
        )}
      </div>
    </div>
  );
};

export default SearchParams;
